(() => {
  if (window.dtMarketDialogsLoaded) return;
  window.dtMarketDialogsLoaded = true;
  let opener = null;
  const restore = () => {
    if (!document.querySelector('dialog.dt-dialog[open]')) {
      document.documentElement.style.overflow = '';
      if (opener?.isConnected) opener.focus();
    }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-dtm-dialog]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.dtmDialog);
      if (!dialog) return;
      opener = trigger;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      dialog.querySelector('[data-dtm-close]')?.focus();
    }
    const close = event.target.closest('[data-dtm-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog.dt-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('dialog.dt-dialog')) restore();
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('dialog.dt-dialog[open]').forEach(dialog => dialog.close());
    restore();
  });
})();
